import type { CompanyTeamMember, TeamRole } from '@indutrust/shared-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import type { InviteCompanyTeamMemberPayload } from '../company-team-api-client.service';

/**
 * Workflow events for Company team management (`/companies/{id}/team_members`).
 *
 * Pattern B (custom workflow) — list load plus invite, role change and remove
 * mutations scoped to a single Company id.
 */
export const companyTeamEvents = eventGroup({
  source: 'company.team',
  events: {
    inviteFailed: type<{ error: string }>(),
    inviteRequested: type<{
      companyId: number;
      payload: InviteCompanyTeamMemberPayload;
    }>(),
    inviteSucceeded: type<CompanyTeamMember>(),
    membersLoadFailed: type<{ error: string }>(),
    membersLoadRequested: type<{ companyId: number }>(),
    membersLoadSucceeded: type<{ members: CompanyTeamMember[] }>(),
    removeFailed: type<{ error: string }>(),
    removeRequested: type<{ companyId: number; memberId: number }>(),
    removeSucceeded: type<{ memberId: number }>(),
    roleChangeFailed: type<{ error: string }>(),
    roleChangeRequested: type<{
      companyId: number;
      memberId: number;
      role: TeamRole;
    }>(),
    roleChangeSucceeded: type<CompanyTeamMember>(),
  },
});
